import { Experiments } from 'constants/experiments'
import SocialProofDialog from 'components/OfferPage/SocialProofDialog'
import { SOCIAL_PROOF_COPY_VARIANTS } from 'hooks/OfferPage/useSocialProofPopup'

interface Props {
  offer: App.Tours.TourV2Offer
  offerImage: App.Image | undefined
}

function TourV2SocialProofDialog({ offer, offerImage }: Props) {
  // Tour V2 offers don't carry a top-level image; the popup needs a representative
  // image, so callers pass the current variation's hero image. Without one there's
  // nothing to render.
  if (!offerImage) return null

  return (
    <SocialProofDialog
      copyVariant={SOCIAL_PROOF_COPY_VARIANTS.tour}
      experiment={Experiments.croSocialProofTours}
      offerImage={offerImage}
      recentPurchases={offer.stats?.recentPurchases}
    />
  )
}

export default TourV2SocialProofDialog
